import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { RoleGuard } from '../guards/role.guard';
import { ProjectGuard } from '../guards/project.guard';

export const content: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('../../auth/auth.module').then(m => m.AuthModule)
	},
	{
		path: 'super-admin',
		loadChildren: () => import('../../components/super-admin/super-admin.module').then(m => m.SuperAdminModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			roles: ['Admin', 'SuperAdmin']
		}
	},
	{
		path: 'admin',
		loadChildren: () => import('../../components/admin/admin.module').then(m => m.AdminModule),
		canActivate: [AuthGuard, RoleGuard, ProjectGuard],
		canActivateChild: [ProjectGuard],
		data: {
			roles: ['Admin', 'SuperAdmin', 'Owner', 'User']
		}
	},
	{
		path: 'front',
		loadChildren: () => import('../../components/front/front.module').then(m => m.FrontModule),
		canActivate: [AuthGuard, RoleGuard, ProjectGuard],
		canActivateChild: [ProjectGuard],
		data: {
			roles: ['Admin', 'SuperAdmin', 'Owner', 'User']
		}
	}
];
